<template>
  <div class="bg_white mt12 pt16 pb16 boxs1">
    <div class="" v-for="value in nselectionOrderList">
      <div class="item_wrap pl15 pr15 bdb pt25 pb25">
        <div class="item_contents">
          <ProductImage :productId="value.productId" :genreId="value.purchaseOrderItemList[0].genreId" :imageClass="'item_image'" />

          <p class="item_title ab c5a" v-html="value.productName">{{ value.productName}}</p>
        </div>
        <div class="contents_detail">
          <div v-if="item.orderCount != 0" class="count_wrap" v-bind:class="{ bdb: item.orderYear != 0 && item.orderMonth != 0 || item.orderCount != 0 }" v-for="item in value.purchaseOrderItemList">
            <p class="month rb c5a"><span v-if="item.orderMonth != 0">{{ item.orderMonth }}<span class="month_text">月</span></span></p>
            <p v-if="item.orderCount != 0" class="count rb c5a"><span class="count_text ab">数量</span>{{ item.orderCount }}</p>
          </div>
          <div v-if="isSelectableChildFund(value.productId, value.purchaseOrderItemList[0].genreId)" class="child_wrap c5a">
            <span class="child_text ab">こども基金：</span>
            <span class="child_add ab">{{ value.child ? '支援する': '支援しない' }}</span>
          </div>

          <div class="price_wrap c5a">
            <p class="price rb"><span class="yen">￥</span>{{ value.totalPrice.toLocaleString() }}</p>
            <p class="point rm"><span class="point_text ab">ポイント：</span>{{ calcItemTotalPoint(value.purchaseOrderItemList, value.productId, value.purchaseOrderItemList[0].genreId) }}<span class="pt ab">pt</span></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="edit" class="edit_wrap confirm_coupon pr25">
      <router-link :to="{ name: 'NSelectionSelectProducts' }" class="edit btn_yellow btn_mini">編集</router-link>
    </div>
  </div>

</template>

<script>
import SectionTitle from '@/components/common/SectionTitle';
import { mapGetters } from 'vuex';
import ProductFunction from '@/model/n-selection/selectProducts'
import ProductImage from '@/components/n-selection/parts/ProductImage'

export default {
  props: ['edit'],
  components: {
    SectionTitle,
    ProductImage
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    isSelectableChildFund(productId, genreId) {
      const indexList = ProductFunction.productIndex(this.productsList, productId, genreId);
      if(indexList == undefined) return false;
      return this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.selectableChildFund;
    },
    calcItemTotalPoint(purchaseOrderItemList, productId, genreId) {
      let point = 0
      const indexList = ProductFunction.productIndex(this.productsList, productId, genreId);
      if(indexList == undefined) return 0;
      let productPoint = this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.point;
      for (let i = 0; i < purchaseOrderItemList.length; i++) {
        point = point + productPoint * purchaseOrderItemList[i].orderCount;
      }

      return point;
    },
  },
  computed: mapGetters(
    'nselection', [
      'productsList',
      'nselectionOrderList',
    ]
  ),
}
</script>

<style lang="css" scoped>
.bc_number {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.item_wrap {
  -ms-align-items: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.item_contents {
  width: 31%;
}

.item_image {
  margin: auto;
  width: 90%;
}

.item_title {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
}

.contents_detail {
  width: 57.4%;
}

.count_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.month {
  font-size: 24px;
}

.month_text {
  font-size: 16px;
  margin-left: 2px;
}

.count {
  font-size: 26px;
}

.count_text {
  font-size: 14px;
  margin-right: 19px;
}

.child_wrap {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 22px;
}

.price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}
.point {
  font-size: 16px;
}
.point_text {
  font-size: 12px;
}
.pt {
  font-size: 14px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/ConfirmProductsList.vue